import {
  Design,
  DesignChannelType,
  DesignRootSettings,
  DesignRuntimeEngine
} from '../../../types';
import { normalizeDisambiguationPrompt } from './normalize-disambiguation-prompt';
import { normalizeNoInputTimeoutOverride } from './normalize-no-input-timeout-override';

type NonDefaultKeys = (
  // Common module specific settings.
  'allowSessionVariableAccess'
  // Handled later in normalize.
  | 'channels'
  | 'defaultChannel'
  | 'noInputTimeoutOverride'
);

/**
 * Normalize @see DesignRootSettings.
 *
 * @note @see normalizeLegacySettings normalizes older settings.
 */
export function normalizeRootSettings(serialized: Design) {
  const defaultRootSettings: Omit<DesignRootSettings, NonDefaultKeys> = {
    features: {},
    lastLocalChange: window.apm?.timestamp ?? Date.now(),
    runtimeEngine: DesignRuntimeEngine.nashorn
  };
  serialized.rootSettings = {
    ...defaultRootSettings,
    ...serialized.rootSettings
  };
  const { rootSettings } = serialized;
  let {
    channels,
    csvIntentLabelTableId,
    defaultChannel
  } = rootSettings;

  if (!channels) {
    channels = (serialized.omniChannel.isOmniChannel) ? (
      {
        [DesignChannelType.facebook]: {},
        [DesignChannelType.sms]: {},
        [DesignChannelType.voice]: {},
        [DesignChannelType.webChat]: {}
      }
    ) : (
      { [DesignChannelType.voice]: {} }
    );
    rootSettings.channels = channels;
  }

  if (
    csvIntentLabelTableId
    && !serialized.csvData.some(({ id }) => {
      return id === csvIntentLabelTableId;
    })
  ) {
    delete rootSettings.csvIntentLabelTableId;
  }

  if (!defaultChannel) {
    defaultChannel = (DesignChannelType.voice in channels) ? (
      DesignChannelType.voice
    ) : Object.keys(channels)[0] as DesignChannelType;
    rootSettings.defaultChannel = defaultChannel;
  }

  normalizeDisambiguationPrompt(rootSettings, serialized);
  normalizeNoInputTimeoutOverride(rootSettings, serialized.noInputTimeout);
}
